import * as React from "react";
import { Component } from "react";
import { Link } from "react-router-dom";
import { Validation } from "../../utils";
import Carousel from "react-bootstrap/Carousel";

class Testimonials extends Component {
  componentDidMount() {
    // clear localstorage if user not logged
    if (Validation.isUserLogged()) {
      this.setState({ isAuthenticated: true });
    } else {
      localStorage.clear();
    }
  }

  handleOnChange = (event: React.FormEvent<HTMLInputElement>) => {
    const { name, value } = event.currentTarget;
    const state: any = { ...this.state };
    state[name] = value;
    this.setState(state);
  };

  responsiveMenu = () => {
    let navbarToggle = this.select(".mobile-nav-toggle");
    navbarToggle.classList.toggle("bi-list");
    navbarToggle.classList.toggle("bi-x");
    this.select("#navbar").classList.toggle("navbar-mobile");
  };

  closeMobileMenuNav = () => {
    if (this.select("#navbar").classList.contains("navbar-mobile text-black")) {
      let navbarToggle = this.select(".mobile-nav-toggle text-black");
      navbarToggle.classList.toggle("bi-list");
      navbarToggle.classList.toggle("bi-x");
      this.select("#navbar").classList.remove("navbar-mobile");
    }
  };

  select = (el: any, all = false) => {
    el = el.trim();
    return document.querySelector(el);
  };

  render() {
    // const {
    //   handleOnChange,
    //   onSubmit,
    //   state: { userName, password, isAuthenticated },
    // } = this;
    // if (isAuthenticated) {
    //   const role: any = UserHelper.getUserDetails()?.user_role_id;
    //   switch (role) {
    //     case userRoles.VOLUNTEER:
    //       return <Redirect to="/volunteerDashboard" />;

    //     case userRoles.STATE_ADMIN:
    //     case userRoles.SUPER_ADMIN:
    //     case userRoles.DISTRICT_ADMIN:
    //       return <Redirect to="/projectListDashboard" />;

    //     default:
    //       return <Redirect to="/" />;
    //   }
    // }

    // let slides = [
    // <div className="d-flex justify-content-center">
    //   <div className="tcontainer  ">
    //     <img src="/assets/img/Volunter4.jpg" alt="Samantha" />
    //     <p className="tdesc mt-4">
    //       It's been a year since we commenced our journey with Grow Trees to
    //       plant 50,000 trees . It is heart-warming to see 96% of trees planted
    //       survived by the end of the year. A beautiful concept and well
    //       executed!
    //     </p>
    //     <p className="tname">Samantha</p>
    //   </div>
    // </div>,
    //   <div className="d-flex justify-content-center">
    //     <div className="tcontainer  ">
    //       <img src="/assets/img/Volunter1.jpg" alt="John" />
    //       <p className="tdesc mt-4">
    //         It's been a year since we commenced our journey with Grow Trees to
    //         plant 50,000 trees . It is heart-warming to see 96% of trees planted
    //         survived by the end of the year. A beautiful concept and well
    //         executed!
    //       </p>
    //       <p className="tname">John</p>
    //     </div>
    //   </div>,
    //   <div className="d-flex justify-content-center">
    //     <div className="tcontainer  ">
    //       <img src="/assets/img/Volunter2.jpg" alt="Paul" />
    //       <p className="tdesc mt-4">
    //         It's been a year since we commenced our journey with Grow Trees to
    //         plant 50,000 trees . It is heart-warming to see 96% of trees planted
    //         survived by the end of the year. A beautiful concept and well
    //         executed!
    //       </p>
    //       <p className="tname">Paul</p>
    //     </div>
    //   </div>,
    //   <div className="d-flex justify-content-center">
    //     <div className="tcontainer  ">
    //       <img src="/assets/img/Volunter3.jpg" alt="Daisy" />
    //       <p className="tdesc mt-4">
    //         It's been a year since we commenced our journey with Grow Trees to
    //         plant 50,000 trees . It is heart-warming to see 96% of trees planted
    //         survived by the end of the year. A beautiful concept and well
    //         executed!
    //       </p>
    //       <p className="tname">Daisy</p>
    //     </div>
    //   </div>,
    // ];
    return (
      <div>
        <main>
          <header id="homeheaderNew" className="d-flex align-items-center">
            <nav id="navbar" className="navbar w-100">
              <div className="homeheader-items">
                <ul>
                  <li className="ml-2 c-hover d-flex align-items-center ">
                    <Link to="/" className="text-white">
                      Home
                    </Link>
                  </li>
                  <li className="ml-2 c-hover d-flex align-items-center">
                    <Link
                      to="/aboutUs"
                      className="text-white"
                      onClick={() => {
                        this.closeMobileMenuNav();
                      }}
                    >
                      About Us
                    </Link>
                  </li>
                  <li className="ml-2 c-hover d-flex align-items-center">
                    <Link
                      to="/testimonials"
                      className="text-white"
                      onClick={() => {
                        this.closeMobileMenuNav();
                      }}
                    >
                      Testimonials
                    </Link>
                  </li>

                  <li className="ml-2 c-hover d-flex align-items-center">
                    <Link
                      to="/"
                      className="text-white"
                      onClick={() => {
                        this.closeMobileMenuNav();
                      }}
                    >
                      Projects
                    </Link>
                  </li>
                  <li className="ml-2 c-hover d-flex align-items-center">
                    <Link
                      to="/login"
                      className="text-white"
                      // style={{ color: "white" }}
                      onClick={() => {
                        this.closeMobileMenuNav();
                      }}
                    >
                      Sign In
                    </Link>
                  </li>
                </ul>
                <i
                  className="bi bi-list mobile-nav-toggle"
                  onClick={this.responsiveMenu}
                ></i>
              </div>
            </nav>
          </header>
          <section className="bgtestmonials  ">
            <div className="testhead mb-4">Testimonials</div>
            <Carousel variant="dark">
              <Carousel.Item>
                <div className="d-flex justify-content-center">
                  <div className="tcontainer  ">
                    <img src="/assets/img/Volunter4.jpg" alt="Samantha" />
                    <p className="tdesc mt-4">
                      It's been a year since we commenced our journey with Grow
                      Trees to plant 50,000 trees . It is heart-warming to see
                      96% of trees planted survived by the end of the year. A
                      beautiful concept and well executed!
                    </p>
                    <p className="tname">Samantha</p>
                  </div>
                </div>
              </Carousel.Item>
              <Carousel.Item>
                <div className="d-flex justify-content-center">
                  <div className="tcontainer  ">
                    <img src="/assets/img/Volunter1.jpg" alt="John" />
                    <p className="tdesc mt-4">
                      It's been a year since we commenced our journey with Grow
                      Trees to plant 50,000 trees . It is heart-warming to see
                      96% of trees planted survived by the end of the year. A
                      beautiful concept and well executed!
                    </p>
                    <p className="tname">John</p>
                  </div>
                </div>
              </Carousel.Item>
              <Carousel.Item>
                <div className="d-flex justify-content-center">
                  <div className="tcontainer  ">
                    <img src="/assets/img/Volunter2.jpg" alt="Paul" />
                    <p className="tdesc mt-4">
                      It's been a year since we commenced our journey with Grow
                      Trees to plant 50,000 trees . It is heart-warming to see
                      96% of trees planted survived by the end of the year. A
                      beautiful concept and well executed!
                    </p>
                    <p className="tname">Paul</p>
                  </div>
                </div>
              </Carousel.Item>
              <Carousel.Item>
                <div className="d-flex justify-content-center">
                  <div className="tcontainer  ">
                    <img src="/assets/img/Volunter3.jpg" alt="Daisy" />
                    <p className="tdesc mt-4">
                      It's been a year since we commenced our journey with Grow
                      Trees to plant 50,000 trees . It is heart-warming to see
                      96% of trees planted survived by the end of the year. A
                      beautiful concept and well executed!
                    </p>
                    <p className="tname">Daisy</p>
                  </div>
                </div>
              </Carousel.Item>
            </Carousel>

            {/* <div className="d-flex justify-content-center">
              <div className="tcontainer  ">
                <img src="/assets/img/Volunter4.jpg" alt="Samantha" />
                <p className="tdesc mt-4">
                  It's been a year since we commenced our journey with Grow
                  Trees to plant 50,000 trees . It is heart-warming to see 96%
                  of trees planted survived by the end of the year. A beautiful
                  concept and well executed!
                </p>
                <p className="tname">Samantha</p>
              </div>
            </div>
            <div className="d-flex justify-content-center">
              <div className="tcontainer  ">
                <img src="/assets/img/Volunter1.jpg" alt="John" />
                <p className="tdesc mt-4">
                  It's been a year since we commenced our journey with Grow
                  Trees to plant 50,000 trees . It is heart-warming to see 96%
                  of trees planted survived by the end of the year. A beautiful
                  concept and well executed!
                </p>
                <p className="tname">John</p>
              </div>
            </div>
            <div className="d-flex justify-content-center">
              <div className="tcontainer  ">
                <img src="/assets/img/Volunter2.jpg" alt="Paul" />
                <p className="tdesc mt-4">
                  It's been a year since we commenced our journey with Grow
                  Trees to plant 50,000 trees . It is heart-warming to see 96%
                  of trees planted survived by the end of the year. A beautiful
                  concept and well executed!
                </p>
                <p className="tname">Paul</p>
              </div>
            </div>
            <div className="d-flex justify-content-center">
              <div className="tcontainer  ">
                <img src="/assets/img/Volunter3.jpg" alt="Daisy" />
                <p className="tdesc mt-4">
                  It's been a year since we commenced our journey with Grow
                  Trees to plant 50,000 trees . It is heart-warming to see 96%
                  of trees planted survived by the end of the year. A beautiful
                  concept and well executed!
                </p>
                <p className="tname">Daisy</p>
              </div>
            </div> */}

            {/* {data.map((slide, index) => {
              return (
                <div className="d-flex justify-content-center">
                  <div className="tcontainer  ">
                    <img src={slide.image} alt={slide.image} />
                    <p className="tdesc mt-4">{slide.content}</p>
                    <p className="tname">{slide.name}</p>
                  </div>
                </div>
              );
            })} */}

            {/* <Carousel
              slides={slides}
              autoplay={false}
              interval={1000}
              
            /> */}

            {/* <div className="testimonials-scroll">
              {data.map((obj, index) => (
                <div key={index} className="testimonial-card">
                  <div className="d-flex m-0">
                    <img
                      src={obj.image}
                      alt={obj.name}
                      className="testimonial-image"
                    />
                    <div>
                      <div className="testimonial-data">{obj.content}</div>
                      <div className="testimonial-name">{obj.name}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div> */}
          </section>
          <section className="bgfooter  ">
            <div className="container">
              <div className="corow">
                <div className="col-lg-3 col-md-6 col-xs-6 px-3 d-none d-md-block footer-info">
                  <div className="footerhead ">About Us</div>
                  {/* <img
                src={`${process.env.PUBLIC_URL}/assets/img/Vruksha_logo_white.png`}
                alt="logo"
              /> */}
                  <p className="p mt-2 mb-2 text-black">
                    The Art of Living is a multi-faceted, non-profit
                    organization with a global presence. Founded in 1981 by a
                    world renowned humanitarian and spiritual leader, Gurudev
                    Sri Sri Ravi Shankar ji.
                    {/* {props.about_art_of_living} */}
                    {/* Operating in 156 countries, The Art of Living is a non-profit, educational and humanitarian organization founded in 1981 by the world-renowned humanitarian and spiritual teacher - Gurudev Sri Sri Ravi Shankar. All our programs are guided by Gurudev’s philosophy: “Unless we have a stress-free mind and a violence-free society, we cannot achieve world peace.” */}
                  </p>
                </div>
                <div className="col-lg-3 col-md-6 col-xs-6 px-3 footer-links">
                  <div>
                    <Link to="/privacyPolicy" className="footerhead ">
                      Privacy Policy
                    </Link>
                  </div>
                  <div>
                    <Link to="/termsAndCondition" className="footerhead ">
                      Terms & Conditions
                    </Link>
                  </div>
                  {/* <div className="footerhead ">Privacy & Policy</div> */}
                  {/* <img
                src={`${process.env.PUBLIC_URL}/assets/img/Vruksha_logo_white.png`}
                alt="logo"
              /> */}
                </div>

                <div className="col-lg-2 col-md-4 col-xs-5 px-2 footer-links">
                  <div>
                    <Link to="/" className="footerhead ">
                      Home
                    </Link>
                  </div>
                  <div>
                    <Link to="/login" className="footerhead ">
                      Sign In
                    </Link>
                  </div>
                  <div>
                    <Link to="/signup" className="footerhead ">
                      Register
                    </Link>
                  </div>
                </div>
                <div className="col-lg-2 col-md-4 col-xs-5 px-2 footer-links">
                  <div>
                    <Link to="/aboutUs" className="footerhead ">
                      About US
                    </Link>
                  </div>
                  <div>
                    <Link to="/testimonials" className="footerhead ">
                      Testimonials
                    </Link>
                  </div>
                  <div>
                    <Link to="/" className="footerhead ">
                      Projects
                    </Link>
                  </div>
                </div>

                <div className="col-lg-2 col-md-4 col-xs-5 px-2 footer-links">
                  <div className="footerhead"> Social Media</div>
                  <div className="d-flex align-items-center ">
                    <div className="social-links  mt-4 px-2">
                      <a
                        target={"_blank"}
                        href="https://twitter.com/ArtofLiving"
                        className="twitter"
                      >
                        <i className="bi bi-twitter"></i>
                      </a>
                      <a
                        target={"_blank"}
                        href="https://facebook.com/ArtofLiving"
                        className="facebook px-1 "
                      >
                        <i className="bi bi-facebook"></i>
                      </a>
                      <a
                        target={"_blank"}
                        href="https://instagram.com/artofliving"
                        className="instagram px-1"
                      >
                        <i className="bi bi-instagram"></i>
                      </a>
                      {/* <Link
                      to={siteData.linkedInAccountLink}
                      className="linkedin px-1"
                    >
                      <i className="bi bi-linkedin"></i>
                    </Link> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className="footer-content2">
            <footer id="footer-new">
              <div className="container">
                <div className="">
                  <div className="">
                    <div className="">
                      <div className="">
                        &copy; Copyright{" "}
                        <strong>
                          <span>Vruksha</span>
                        </strong>
                        . All Rights Reserved
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </footer>
          </div>
        </main>

        {/* <section id="Login">
          <div className="Container">
            <div className="Login_card">
              <div className="card">
                <div className="text-center Company_Logo mb-3">
                  <Link to="/">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/img/Vruksha_logo.png`}
                      alt="logo"
                    />
                  </Link>
                </div>

                <div className="email-login">
                  <form>
                    <FieldItem
                      onChange={handleOnChange}
                      value={userName}
                      name="userName"
                      placeholder="Email ID"
                      type={FIELD_TYPES.TEXT}
                      className="form-control"
                    />
                    <FieldItem
                      onChange={handleOnChange}
                      value={password}
                      name="password"
                      placeholder="Password"
                      type={FIELD_TYPES.TEXT_EYE}
                      className="form-control mt-4"
                      iconClassName="loginPasswordEye"
                    />
                  </form>
                </div>

                <span>
                  <Button
                    type="button"
                    onClick={onSubmit}
                    className="btn cta-btn"
                    label="Log In"
                    id="login"
                  />
                </span>
                <ul className="Remmber_Forgot_box">
                  <li>
                    <div className="form-check">
                      <input
                        className="form-check-input "
                        type="checkbox"
                        value=""
                        id="defaultCheck1"
                      />
                      <label className="form-check-label">Remember Me</label>
                    </div>
                  </li>
                  <li className="forget-pass">
                    <Link to="/forgetpassword"> Forgot Password?</Link>
                  </li>
                </ul>

                <div className="Not_registed_box">
                  <p className="subtitle">
                    Not Registered? <Link to="/signup"> Sign-up now</Link>
                  </p>
                </div>

                <div className="social-login">
                  <button className="google-btn">
                    <img
                      alt="Google"
                      src="data:image/svg+xml;base64,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"
                    />
                    <p className="btn-text"> Google</p>
                  </button>
                  <button className="fb-btn">
                    <img
                      alt="FB"
                      src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDI5MS4zMTkgMjkxLjMxOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjkxLjMxOSAyOTEuMzE5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8Zz4NCgk8cGF0aCBzdHlsZT0iZmlsbDojM0I1OTk4OyIgZD0iTTE0NS42NTksMGM4MC40NSwwLDE0NS42Niw2NS4yMTksMTQ1LjY2LDE0NS42NmMwLDgwLjQ1LTY1LjIxLDE0NS42NTktMTQ1LjY2LDE0NS42NTkNCgkJUzAsMjI2LjEwOSwwLDE0NS42NkMwLDY1LjIxOSw2NS4yMSwwLDE0NS42NTksMHoiLz4NCgk8cGF0aCBzdHlsZT0iZmlsbDojRkZGRkZGOyIgZD0iTTE2My4zOTQsMTAwLjI3N2gxOC43NzJ2LTI3LjczaC0yMi4wNjd2MC4xYy0yNi43MzgsMC45NDctMzIuMjE4LDE1Ljk3Ny0zMi43MDEsMzEuNzYzaC0wLjA1NQ0KCQl2MTMuODQ3aC0xOC4yMDd2MjcuMTU2aDE4LjIwN3Y3Mi43OTNoMjcuNDM5di03Mi43OTNoMjIuNDc3bDQuMzQyLTI3LjE1NmgtMjYuODF2LTguMzY2DQoJCUMxNTQuNzkxLDEwNC41NTYsMTU4LjM0MSwxMDAuMjc3LDE2My4zOTQsMTAwLjI3N3oiLz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjwvc3ZnPg0K"
                    />
                    <p className="btn-text"> Facebook</p>
                  </button>
                </div>
              </div>
            </div>

            <div className="Copyright_box">Copyright &copy; 2021, Vruksha</div>
          </div>
        </section> */}
      </div>
    );
  }
}

export default Testimonials;
